import React, { useMemo, useState } from "react";
import { Box, Flex, Text, Loader } from "@mantine/core";
import { IconChevronLeft, IconSearch, IconPlus, IconSettings, IconRefresh } from "@tabler/icons-react";
import useSharedStyles from "../sharedStyles";

const FailedReportsView = ({ rows, retryingId, onBack, onGenerate, onOpenSettings, onRetry }) => {
  const { classes } = useSharedStyles();
  const [search, setSearch] = useState("");

  const filtered = useMemo(() => {
    if (!search) return rows;
    const q = search.toLowerCase();
    return rows.filter(
      (r) =>
        r.client.toLowerCase().includes(q) ||
        r.provider.toLowerCase().includes(q) ||
        r.facility.toLowerCase().includes(q)
    );
  }, [rows, search]);

  return (
    <Box className={classes.content}>
      <Flex className={classes.crumbBar}>
        <button className={classes.backBtn} onClick={onBack}>
          <IconChevronLeft size={16} /> Back
        </button>
      </Flex>

      <Flex className={classes.toolbarCard}>
        <button className={classes.btnAdd} onClick={onGenerate}>
          <Flex align="center" gap={8}>
            <IconPlus size={16} />
            Generate Quarterly
          </Flex>
        </button>
        <button className={classes.iconBtnSquare} onClick={onOpenSettings} aria-label="Report settings">
          <IconSettings size={18} />
        </button>
      </Flex>

      <Text className={classes.wlTitle}>Failed Reports</Text>

      <Box className={classes.tableWrap}>
        <Flex className={classes.cardToolbar}>
          <Flex className={classes.search}>
            <IconSearch size={15} />
            <input
              className={classes.searchInput}
              placeholder="Search client, provider or facility"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </Flex>
        </Flex>

        <Box className={classes.tableScroll}>
          <table className={classes.table}>
            <thead>
              <tr>
                <th>Client</th>
                <th>Provider</th>
                <th>Facility</th>
                <th>Review Period</th>
                <th>Failed on</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id}>
                  <td className={classes.tdMain}>{r.client}</td>
                  <td>{r.provider}</td>
                  <td>{r.facility}</td>
                  <td className={classes.num}>{r.period}</td>
                  <td className={classes.num}>{r.failedOn}</td>
                  <td>
                    <button
                      className={classes.startBtn}
                      disabled={retryingId === r.id}
                      onClick={() => onRetry(r)}
                    >
                      {retryingId === r.id ? <Loader size={13} color="currentColor" /> : <IconRefresh size={13} />}
                      {retryingId === r.id ? "Retrying…" : "Retry"}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Box>

        <Flex className={classes.cardPagination}>
          <Text className={classes.pagInfo}>Showing {filtered.length} failed reports this month</Text>
        </Flex>
      </Box>
    </Box>
  );
};

export default FailedReportsView;
